import { useMemo } from 'react';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import { useLanguage } from '../sitecoreContext';
const useFormatPriceWithCurrentLanguage = () => {
    const language = useLanguage();
    return useMemo(() => (price) => formatPrice(price, language, 2), [language]);
};
export default useFormatPriceWithCurrentLanguage;
